module.exports = __webpack_public_path__ + "static/img/iconmenu02.14be2885.svg";